import React, { memo } from 'react';
import { Image } from 'antd';


// Must be assigned to an onClick event
function onClickImage(e, parentContainer = null) {
  let currentImgSRC;
  if (e.currentTarget) {
    currentImgSRC = e.currentTarget.querySelector("img").src;
    // Keep track of our parent container, as not to include other containers
    parentContainer = e.currentTarget.parentElement;
  } else {
    currentImgSRC = e;
  }
  
  let PreviewWrapDoms = document.getElementsByClassName(
    "ant-image-preview-wrap"
  );
  let ImgPreviewBodyDom = document.getElementsByClassName(
    "ant-image-preview-body"
  )[0];
  // I don't see any kind of callback accessible for when the target
  // gets rendered, so we simply wait until the time is right.
  setTimeout(function () {
    // Previous viewers aren't self clearing, so I added that in.
    // Otherwise this breaks with multiple galleries
    if (typeof ImgPreviewBodyDom === "undefined" || PreviewWrapDoms.length > 1 ) {
      for (let WrapIndex = 0; WrapIndex < PreviewWrapDoms.length; WrapIndex++) {
        if ( window.getComputedStyle(PreviewWrapDoms[WrapIndex]).display === "none") {
          PreviewWrapDoms[WrapIndex].parentElement.parentElement.remove();
        }
      }
      onClickImage(currentImgSRC, parentContainer);
      return;
    }

    let ImgPreviewDom = ImgPreviewBodyDom.getElementsByClassName(
      "ant-image-preview-img"
    )[0];
    let LeftArrowDom = ImgPreviewBodyDom.getElementsByClassName(
      "ant-image-preview-switch-left"
    )[0];
    let RightArrowDom = ImgPreviewBodyDom.getElementsByClassName(
      "ant-image-preview-switch-right"
    )[0];
    // Assigning event listeners for the left and right arrows.
    if (LeftArrowDom.getAttribute("listener") !== "true")
      LeftArrowDom.addEventListener("click", (e) => {
        e.preventDefault();
        onClickImage(
          LeftArrowDom.getAttribute("data-img-prev"),
          parentContainer
        );
      });
    LeftArrowDom.setAttribute("listener", "true");
    // Now the right arrow
    if (RightArrowDom.getAttribute("listener") !== "true")
      RightArrowDom.addEventListener("click", (e) => {
        e.preventDefault();
        onClickImage(
          LeftArrowDom.getAttribute("data-img-next"),
          parentContainer
        );
      });
    RightArrowDom.setAttribute("listener", "true");

    // Set these previous and next img sources to the current
    // for the edge cases that may be there is no next or previous
    let previousImgSRC = currentImgSRC;
    let nextImgSRC = currentImgSRC;
    let ImgDoms = parentContainer.getElementsByClassName("ant-image-img");

    // Cycle through the dom in the container to see which we are
    for (let ImgDomIndex = 0; ImgDomIndex < ImgDoms.length; ImgDomIndex++) {
      if (currentImgSRC === ImgDoms[ImgDomIndex].src) {
        if (ImgDomIndex > 0) { //If greater than zero, we know there's a previous
          previousImgSRC = ImgDoms[ImgDomIndex - 1].src;
          LeftArrowDom.setAttribute("data-img-prev", previousImgSRC);
          LeftArrowDom.classList.remove(
            "ant-image-preview-switch-left-disabled"
          );
        } else {
          LeftArrowDom.classList.add("ant-image-preview-switch-left-disabled");
        }
        if (ImgDomIndex + 1 < ImgDoms.length) { // if the next index doesn't exist, no next
          nextImgSRC = ImgDoms[ImgDomIndex + 1].src;
          LeftArrowDom.setAttribute("data-img-next", nextImgSRC);
          RightArrowDom.classList.remove(
            "ant-image-preview-switch-right-disabled"
          );
        } else {
          RightArrowDom.classList.add(
            "ant-image-preview-switch-right-disabled"
          );
        }
        // Once we know where we are in the index, we can set the preview
        // Image source to our desired result.
        //@ts-ignore
        ImgPreviewDom.src = currentImgSRC;

        // We break here because once we know our index, we don't need more
        break;
      }
    }

    // checks for keydown events on the dom.
    this.onkeydown = (e) => {
      e = e || window.event;

      switch (e.keyCode) {
        // we use recursion here to keep everything contained nicely.
        case 37:
          onClickImage(previousImgSRC, parentContainer);
          break;
        case 39:
          onClickImage(nextImgSRC, parentContainer);
          break;
        default:
          break;
      }
    };
  }, 100);
}

function NewCarouselImage({
  fileList,
}) {
  const isEmpty = fileList.length === 0;

  if (isEmpty)
    return <></>;

  return (
    //@ts-ignore
    <Image.PreviewGroup>
      <div style={{
        display: 'flex',
        flexWrap: 'nowrap',
        overflow: 'scroll'
      }}>
        {fileList.map((f) => (
          <Image
            key={f.id}
            src={f.arquivo}
            onClick={onClickImage}
            style={{
              width: 'auto',
              height: '370px',
              objectFit: 'cover',
              padding: '1px'
            }}
          />
        ))}
      </div>
    </Image.PreviewGroup>
  );
}

export default memo(NewCarouselImage);
